const FACILITATE_DELIVERY_TITLE = 'Facilite a entrega';

const FACILITATE_DELIVERY_SUBTITLE =
  'Conte pra gente mais informações sobre o seu endereço. O entregador agradece!';

export { FACILITATE_DELIVERY_TITLE, FACILITATE_DELIVERY_SUBTITLE };
